"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const MenuItemWrapper = styled_components_1.default.div `
  display: flex;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 5px;
  flex-wrap: wrap;
  padding: 16px;
  cursor: pointer;
  &:active {
    border: ${(props) => `1px solid ${props.theme.palette ? props.theme.palette.primary.main : "#000"}`};
  }
`;
const Name = styled_components_1.default.div `
  flex-basis: 80%;
  font-size: 1.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Price = styled_components_1.default.div `
  flex-basis: 20%;
  text-align: right;
`;
const Description = styled_components_1.default.div `
  flex-basis: 80%;
  color: #7a7a7a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const MenuItem = (props) => {
    const { data } = props;
    return (react_1.default.createElement(MenuItemWrapper, null,
        react_1.default.createElement(Name, null, data.name),
        react_1.default.createElement(Price, null, data.price),
        react_1.default.createElement(Description, null, data.caption)));
};
exports.MenuItem = MenuItem;
exports.default = exports.MenuItem;
